/** Un SIRET est composé de 14 chiffres : le SIREN (9) suivi du NIC (5). */
export const SIRET_LONGUEUR = 14;

export const SIRET_MESSAGE_ERREUR = "Le SIRET doit contenir 14 chiffres.";

/** Retire les séparateurs de saisie usuels (espaces, points, tirets). */
export const normaliserSiret = (valeur: string) => valeur.replace(/[\s.-]/g, "");

/** Indique si la valeur, une fois normalisée, est un SIRET exploitable par le back. */
export const siretValide = (valeur: string) =>
  new RegExp(`^\\d{${SIRET_LONGUEUR}}$`).test(normaliserSiret(valeur));
